
import React from 'react';
import ClassBar from './ClassBar';
import { toClassStr } from '_utils/UiHelper';


class SearchResults extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      certifiedSearchId: '',
      certifiedResults: [],
      ugcSearchId: '',
      ugcResults: []
    }
  }

  componentDidMount() {
    const iAmUsingTheDangerousDevelopmentVersion = false;
    if (iAmUsingTheDangerousDevelopmentVersion) {
      // DEVELOPMENT CODE - relies on server to proxy prod data:
      this.stubSearchResults(this.props.q, this.props.op);
    } else {
      // PRODUCTION CODE:
      this.fetchSearchResults(this.props.q, this.props.op);
    }
  }

  render() {
    return (
      <div>
        {this.renderCertifiedClassBars()}
        {this.renderUgcClassBars()}
      </div>
    );
  }

  renderCertifiedClassBars() {
    const crtCount = this.state.certifiedResults.length;

    if (crtCount < 1) {
      return null;
    }

    let self = this;

    const certifiedClassBars = this.state.certifiedResults.map(function(result, i) {
      return (
        <ClassBar
          key={i}
          searchId={self.state.certifiedSearchId}
          classData={result._source}
          classType='certified'
        />
      );
    });

    return (
      <div className="heading-and-results">
        {this.renderClassListHeading('crt', crtCount)}

        <ul className="market-search-results market certified">
          {certifiedClassBars}
        </ul>
      </div>
    );
  }

  renderUgcClassBars() {
    const ugcCount = this.state.ugcResults.length;

    if (ugcCount  < 1) {
      return null;
    }

    let self = this;

    const ugcClassBars = this.state.ugcResults.map(function(result, i) {
      return (
        <ClassBar
          key={i}
          searchId={self.state.ugcSearchId}
          classData={result._source}
          classType='ugc'
        />
      );
    });

    return (
      <div className="heading-and-results">
        {this.renderClassListHeading('ugc', ugcCount)}

        <ul className="market-search-results ugs ugc">
          {ugcClassBars}
        </ul>
      </div>
    );
  }

  renderClassListHeading(type, count) {
    const headings = {
      crt: 'Brainscape Certified Flashcards',
      ugc: 'User Generated Flashcards'
    };

    const classes = toClassStr(['class-list-heading', type]);
    const title = `${headings[type]} (${count})`;

    return (
      <div className={classes}>
        <div className="title">{title}</div>

        <div className="stat-titles">
          <div className="stat-title decks-stat-title">
            <i className="stat-icon decks-icon" />
            <div className="stat-label">Decks</div>
          </div>

          <div className="stat-title flashcards-stat-title">
            <i className="stat-icon flashcards-icon" />
            <div className="stat-label">Flashcards</div>
          </div>

          <div className="stat-title learners-stat-title">
            <i className="stat-icon learners-icon" />
            <div className="stat-label">Learners</div>
          </div>
        </div>
      </div>
    );
  }

  fetchSearchResults(q, op, stub=false) {
    var self = this;

    var data = {
      "api_v1_search_result": {
        "indexes": [ "market", "ugs" ],
        "q": q,
        "operator": op,
        "page": 1,
        "trim_results": true,
      },
      "format": "json"
    }

    if (stub) { data.api_v1_search_result.stub = true }

    $.get("/api/search", data)
    .done(function(data) {
      self.setState({
        certifiedSearchId: data.market_results.market_search_id,
        certifiedResults: data.market_results.hits,
        ugcSearchId: data.ugs_results.ugs_search_id,
        ugcResults: data.ugs_results.hits
      });
    });
  }

  stubSearchResults(q, op) {
    console.log(`USING code-pollution-free STUB Search (if it doesn't work, run "sudo <editor> /etc/hosts" and add "0.0.0.0<tab>localhost.brainscape.com" then visit: "http://localhost.brainscape.com:3000/learn/search?q=...") q: ${q}, op: ${op}`);
    this.fetchSearchResults(q, op, true)
  }
};

export default SearchResults;
